export default {"src":"/_next/static/media/icon_shoutout_locked.c0f4436d.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};